export default function host2() {
  const protocol = 'https://';
  const host = window.location.host;

  if(host.indexOf('dev') != -1 || host.indexOf('localhost') != -1 || host.indexOf('127.0.0.1') != -1){
    return protocol+'sdtvip-api.test.sportsdt.net/frontend/';
  }
  if(host.indexOf('test') != -1){
    return protocol+'sdtvip-api.test.sportsdt.net/frontend/';
  }
  if(host.indexOf('staging') != -1){
    return protocol+'sdtvip-api.staging.sportsdt.net/frontend/';
  }
  return protocol+'sdtvip-api.sportsdt.net/frontend/';
}


// WEBPACK FOOTER //
// ./src/utils/host2.js